import { LanguageModel } from "../models";

export const languages: LanguageModel[] = [
  {
    name: "en",
    displayName: "English",
  },
  {
    name: "de",
    displayName: "Deutsch",
  },
  {
    name: "fr",
    displayName: "Français",
  },
  {
    name: "it",
    displayName: "Italiano",
  },
  {
    name: "es",
    displayName: "Español",
  },
];

export const LanguageCode = {
  English: "en",
  Italin: "it",
  Spanish: "es",
  German: "de",
  French: "fr",
};
